import { Component, inject } from '@angular/core';
import { AbstractComponent } from '../../abstract.component';
import { SolAlertComponent } from '../sol-alert/sol-alert.component';
import { SolLayoutComponent } from '../sol-layout/sol-layout.component';
import { BannerService } from '../../../services/banner.service';
import { SolPageBannerHostState } from './sol-page-banner-host.state';

/**
 * Renders the published page-level banners in the page canvas, stacked, all at once. The list itself
 * stays in `BannerService`: a publisher hands over its set and the host renders every entry published
 * for the page.
 *
 * A page banner states a condition of the page rather than asking for anything, so it renders as an
 * alert with no action and no close, and the shell mounts one of these inside `sol-page` above the
 * routed content.
 */
@Component({
  selector: 'sol-page-banner-host',
  imports: [SolAlertComponent, SolLayoutComponent],
  templateUrl: './sol-page-banner-host.component.html',
})
export class SolPageBannerHostComponent extends AbstractComponent<SolPageBannerHostState> {
  // Dependencies
  private readonly bannerService = inject(BannerService);

  // Computed
  protected readonly items$ = this.compute(state => state.items);

  constructor() {
    super(SolPageBannerHostState.of());

    this.bannerService.watchComputed(
      serviceState => serviceState.pageEntries,
      entries => this.update(state => state.withEntries(entries)),
    );
  }
}
